import { render, staticRenderFns } from "./DomainPageView.vue?vue&type=template&id=32aab365"
import script from "./DomainPageView.vue?vue&type=script&lang=js"
export * from "./DomainPageView.vue?vue&type=script&lang=js"
import style0 from "./DomainPageView.vue?vue&type=style&index=0&id=32aab365&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports